import { create, show, useModal } from "@ebay/nice-modal-react";

import Button from "ds/components/Button";
import Box from "ds/components/Box";
import ModalSimple from "ds/components/ModalSimple";
import ModalContent from "ds/components/Modal/Content";
import { Cross } from "components/icons/generated";
import Icon from "ds/components/Icon";

import styles from "./styles.module.css";

type SessionsConfirmationModalProps = {
  sessionId: string;
  userId: string;

  confirmationCallback: () => void;
  isCurrentSession: boolean;
};

const SessionsConfirmationModal = create(function SessionsConfirmationModal(
  props: SessionsConfirmationModalProps
) {
  const { sessionId, userId, confirmationCallback, isCurrentSession } = props;

  const modal = useModal();

  const handleConfirmation = () => {
    confirmationCallback();
    modal.hide();
  };

  return (
    <ModalSimple>
      <ModalContent align="center">
        <div className={styles.bubble}>
          <div className={styles.innerBubble}>
            <div className={styles.bubbleIconWrapper}>
              <Icon src={Cross} color="danger" className={styles.bubbleIcon} />
            </div>
          </div>
        </div>

        <h3 className={styles.title}>Session deactivation</h3>
        <p className={styles.content}>
          {isCurrentSession ? (
            <>
              Do you want to deactivate your <span className={styles.bold}>current session</span> (
              {sessionId})?
            </>
          ) : (
            <>
              Do you want to deactivate the session <span className={styles.bold}>{userId}</span> (
              {sessionId})?
            </>
          )}
        </p>

        <Box gap="large">
          <Button className={styles.actionCancel} onPress={modal.hide} variant="secondary">
            Cancel
          </Button>
          <Button onPress={handleConfirmation} variant="dangerPrimary">
            {isCurrentSession ? "Logout" : "Deactivate"}
          </Button>
        </Box>
      </ModalContent>
    </ModalSimple>
  );
});

export const showSessionsConfirmationModal = (props: SessionsConfirmationModalProps) =>
  show(SessionsConfirmationModal, props);
